export var REDUCER_KEY = 'signalRouter';